var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-two"},[_c('div',{staticClass:"step-two__wrapper"},[_c('InsuranceTariffsList',{staticClass:"step-two__cards",attrs:{"tariffs-sum":_vm.tariffsSum,"form-data":_vm.formData},on:{"tariff-chosen":_vm.handleTariff,"mounted":_vm.mountedHandler}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }